<template>
    <div>
        <div class="row">
            <div class="col-12 mb-3">
                <div class="d-flex justify-content-end">
                    <app-button 
                        :label="$t('add_customer_address')" 
                        class-name="btn-primary mr-2 mt-2" 
                        :is-disabled="false"
                        @submit="openEditModal()" 
                    />
                </div>
            </div>

            <div class="col-12 col-sm-6 col-xl-3 mb-3 p-2" v-for="(item, index) in addressData" :key="index">
                <div class="card w-80 h-100">
                    <h5 class="card-header">{{ item.name }}</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-9">
                                <p class="card-text"><b>{{ $t('Address') }}: </b>{{ item.address }}</p>
                                <p class="card-text"><b>{{ $t('Phone') }}: </b>{{ item.phone }}</p>
                                <p class="card-text"><b>{{ $t('postal_zip_code') }}: </b>{{ item.postal_zip_code }}</p>
                                <p class="card-text"><b>{{ $t('email') }}: </b>{{ item.email }}</p>
                                <p class="card-text"><b>{{ $t('city') }}: </b>{{ item.city?.name }}</p>
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-center">
                                <div class="icon-wrapper">
                                    <app-icon name="users" />
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-between">
                            <app-button 
                                :label="$t('edit_address_supplier')" 
                                class-name="btn-primary mr-2 mt-2"
                                :is-disabled="false" 
                                @submit="openEditModal(item)" 
                            />

                            <app-button 
                                :label="$t('delete')" 
                                class-name="btn-danger mr-2 mt-2" 
                                :is-disabled="false"
                                @submit="openDeleteModal(item)" 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-address v-if="modalEdit" :dataAddress="dataAddress" :selectedUrl="selectedUrl" @address-updated="handleAddressUpdated"  :company_id="company_id"  @close-modal-address="closeModal" />
        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="demo-delete"
        @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl.js";
import ModalAddress from './../Crud/ModalAddress.vue';
import ModalContacts from './../Crud/ModalContacts.vue';

export default {
    name: "AddProductModal",
    extends: CoreLibrary,
    components: {
        ModalAddress
    },
    data() {
        return {
            preloader: false,
            addressData: [],
            address_id : null,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            inputs: {
                name: '',
                postal_zip_code: '',
                ext: '',
                email: '',
                phone: '',
                address: '',
                country: { id: null, name: null },
                state: { id: null, name: null },
                city: { id: null, name: null },
                isPort : null,
            },
            modalEdit: false,
            dataAddress: {},
            selectedUrl: '',
            company_id: 0,
            stateList: [
                { id: 'Active', value: "Active" },
                { id: 'Inactive', value: "Inactive" }
            ],
            watchActive: false // bandera para controlar el watch
        }
    },

    methods: {
        openEditModal(item) {
            if (!item) {
                let companiesDta = localStorage.getItem('DataCompaniesEdit');
                companiesDta = JSON.parse(companiesDta);
                this.company_id = companiesDta.id
                this.modalEdit = true; 
                this.selectedUrl = ''
                this.dataAddress = {
                    name: null,
                    address: null,
                    country: { id: null, name: null },
                    state: { id: null, name: null },
                    city: { id: null, name: null },
                    postal_zip_code: null,
                    company_contact_id: null,
                    email: null,
                    phone: null,
                    ext: null,
                    isPort : null,
                };
            }
            else {
                this.company_id = 0
                this.dataAddress = {
                    id : item.id,
                    name: item.name,
                    address: item.address,
                    country: { id: item.country?.id, name: item.country?.name },
                    state: { id: item.state?.id, name: item.state?.name },
                    city: { id: item.city?.id, name: item.city?.name },
                    postal_zip_code: item.postal_zip_code,
                    company_contact_id: item.company_contact_id,
                    email: item.email,
                    phone: item.phone,
                    ext: item.ext,
                    isPort : item.is_port,
                };                 
                this.selectedUrl = `${actions.COMPANIESADDRESS}/${item.id}`
                this.modalEdit = true;
            }
        },

        handleAddressUpdated(updatedContact) {
            const existingIndex = this.addressData.findIndex(contact => contact.id === updatedContact.id);
            if (existingIndex !== -1) {
                this.$set(this.addressData, existingIndex, updatedContact);
            } else {
                this.addressData.push(updatedContact);
            }
        },

        closeModal(){
            this.modalEdit = false
            this.dataAddress = {}
            this.selectedUrl = ''
        },

        confirmed() {
            let url = `company-address/${this.address_id}`;    
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    const base_url = localStorage.getItem("base_url");
                    window.location.href = `${base_url}/suppliers/list/suppliers`;
                }).catch(({ error }) => {
                    console.log(error);
                    this.$toastr.w('Address assigned to a contract');
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },

        openDeleteModal(item) {
            this.address_id = item.id;
            this.deleteConfirmationModalActive = true;
        },

        reSetData() {
            this.selectedUrl = '';
        },
    },

    watch: {
        inputs: {
            deep: true, // Para detectar cambios profundos en el objeto
            handler(newVal) {
                localStorage.setItem('DataAddressEdit', JSON.stringify(newVal));
            }
        }
    },

    created() {
        const savedInputs = localStorage.getItem('DataAddressEdit');
        if (savedInputs) {
            this.addressData = JSON.parse(savedInputs);

        }
    }
}

</script>
